import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as actions from '../actions/debt-analysis-widget-configuration.actions';
import { DebtAnalysisWidgetConfigurationHttpService } from '../services/debt-analysis-widget-configuration.http.service';
import { DebtAnalysisWidgetConfiguration } from '../models/debt-analysis-widget-configuration.model';


@Injectable()
export class DebtAnalysisWidgetConfigurationEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly debtAnalysisWidgetConfigurationHttpService: DebtAnalysisWidgetConfigurationHttpService
  ) { }

  
  loadAll$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<actions.LoadAll>(actions.LOAD_ALL),
    switchMap(action => {
      return this
        .debtAnalysisWidgetConfigurationHttpService
        .getConfigs().pipe(
          map((configs: Array<DebtAnalysisWidgetConfiguration>) =>
            new actions.LoadAllComplete(new actions.DebtAnalysisWidgetConfigsActionPayload(configs))),
          catchError(err => of(new actions.LoadAllError(new actions.DebtAnalysisWidgetConfigsActionPayload(null, err))))
        );
    })));

}
